// extracted by mini-css-extract-plugin
export default {"group":"components--group--GlR8n","infoBox":"components--infoBox--lvLr4","value":"components--value--Ut1wJ"};